module.exports = __webpack_public_path__ + "static/media/scdream3.e9333bd5.woff2";